import React, {useMemo, useState} from 'react';
import {capitalizeFirstLetter, convertHour24ToHour12, generateTimeDescription} from "./utils";
import IcLocation from '../../../../../../../../../../../../../../../Assets/Icons/location.svg';
import IcHeart from '../../../../../../../../../../../../../../../Assets/Icons/heart-gray.svg';
import IcHeartActive from '../../../../../../../../../../../../../../../Assets/Icons/heart-purple.svg';
import './MarketplaceCard.scss'
import axios from "axios";

const MarketplaceCard = ({item, onRemoveFavorite}) => {
  const [isFavorite, setIsFavorite] = useState(item.favorite);

  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);

    let Req = {
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        id: item.id,
        favorite: !isFavorite,
      },
      baseURL:
        window.localStorage.getItem("BaseURL") +
        `/services/projectmanagement/api/stores/${item.id}`,
    };

    axios(Req)
      .then(res => {
        if (!res.data.favorite){
          onRemoveFavorite(res.data);
        }
      })
      .catch(() => {setIsFavorite(isFavorite)})
  }

  const {isOpen, text, untilDay, untilTime} = useMemo(() => generateTimeDescription(item.operationalHours) || {}, [item.operationalHours]);

  const showStoreTimeDescription = text && untilDay && untilTime

  const handleGoogleSearch = (query) => {
    window.open(`https://www.google.com/search?q=${query}`, '_blank');
  }

  const handleClickCall = () => {
    if (item.phone) {
      window.location.href = `tel:${item.phone}`
    } else {
      handleGoogleSearch(item.title)
    }
  }

  const handleClickWebsite = () => {
    if (item.website) {
      window.open(item.website, '_blank');
    } else {
      handleGoogleSearch(item.title)
    }
  }

  const handleClickDirection = () => {
    if (item.location) {
      // window.open(`https://www.google.com/maps/search/?api=1&query=${item.location.lat},${item.location.lng}`, '_blank');
      window.open(`https://www.google.com/maps/dir/home/${item.location.lat},${item.location.lng}`, '_blank');
    }
  }

  return (
    <div className="marketplace-card">
      <img src={IcLocation} alt='location' className='icon'/>

      <div className='marketplace-card__content'>
        {/*title & favorite*/}
        <div className='marketplace-card__content__section1'>
          <span className='title'>{item.title}</span>
          <img
            onClick={toggleFavorite}
            className='icon'
            alt='heart'
            src={isFavorite ? IcHeartActive : IcHeart}
          />
        </div>

        {/*store open time, review*/}
        {showStoreTimeDescription && (
          <div className='marketplace-card__content__section2'>
            <span className={isOpen ? 'open' : 'close'}>{text}</span>
            &nbsp;until {capitalizeFirstLetter(untilDay)} {convertHour24ToHour12(untilTime)}{item.category ? `. ${item.category}` : null} . {item.review?.score} ({item.review?.count} Reviews)
          </div>
        )}

        {/*description & source*/}
        <div className='marketplace-card__content__section3'>
          {item.description && <span>{item.description}</span>}
          <span className='chip-source'>{item.source}</span>
        </div>

        {/*actions*/}
        <div className='marketplace-card__content__section4'>
        <span className='chip-action' onClick={handleClickDirection}>Direction</span>

          {item?.website && <span className='chip-action' onClick={handleClickWebsite}>Website</span>}

          {item?.phone && <span className='chip-action' onClick={handleClickCall}>Call</span>}
        </div>
      </div>
    </div>
  );
};

export default MarketplaceCard;
